import { useState, useCallback } from 'react';

export const useEmbeddedWizard = ({
  currentStepIndex,
  isLastStep,
  complete,
  onComplete,
  goToStep,
  goPrev,
}) => {
  const [embeddedWizardRef, setEmbeddedWizardRef] = useState(null);
  const [embeddedNavState, setEmbeddedNavState] = useState({
    canGoNext: false,
    canGoPrev: false,
    isLastStep: false,
  });

  const handleEmbeddedNext = useCallback(() => {
    if (embeddedWizardRef) {
      embeddedWizardRef.handleNext();
    }
  }, [embeddedWizardRef]);

  const handleEmbeddedPrev = useCallback(() => {
    if (embeddedWizardRef) {
      const isEmbeddedFirstStep = embeddedWizardRef.handlePrev();
      if (isEmbeddedFirstStep) {
        goToStep(currentStepIndex - 1);
      }
    } else {
      goPrev();
    }
  }, [embeddedWizardRef, currentStepIndex, goPrev, goToStep]);

  const handleEmbeddedComplete = useCallback(() => {
    if (isLastStep) {
      complete();
      if (onComplete) onComplete();
    } else {
      goToStep(currentStepIndex + 1);
    }
  }, [currentStepIndex, goToStep, isLastStep, complete, onComplete]);

  const handleEmbeddedNavChange = useCallback((navState) => {
    setEmbeddedNavState(navState);
  }, []);

  const setEmbeddedWizardRefCallback = useCallback((ref) => {
    setEmbeddedWizardRef(ref);
  }, []);

  return {
    embeddedWizardRef,
    embeddedNavState,
    handleEmbeddedNext,
    handleEmbeddedPrev,
    handleEmbeddedComplete,
    handleEmbeddedNavChange,
    setEmbeddedWizardRefCallback,
  };
};
